(() => {
  function splitZipCity(value) {
    const match = String(value || '').trim().match(/^(\d{5})\s+(.+)$/);
    if (!match) return null;
    return { postalCode: match[1], locality: match[2].trim() };
  }

  function ensurePageEntity(schema) {
    if (!schema || typeof schema !== 'object') return false;
    const profileUrl = window.location.origin + window.location.pathname;
    schema.mainEntityOfPage = {
      '@type': 'WebPage',
      '@id': profileUrl + '#webpage',
      url: profileUrl
    };
    return true;
  }

  function normalizeOrganizationSchema() {
    const organization = document.getElementById('ipv-organization-schema');
    if (!organization) return false;
    if (organization.dataset.zbSchemaNormalized === 'true') return true;

    try {
      const schema = JSON.parse(organization.textContent || '{}');
      if (!schema || schema['@type'] !== 'Organization') return false;

      if (schema.address && typeof schema.address === 'object') {
        const parsed = splitZipCity(schema.address.addressLocality);
        if (parsed) {
          schema.address.postalCode = parsed.postalCode;
          schema.address.addressLocality = parsed.locality;
        }
      }

      ensurePageEntity(schema);
      organization.dataset.zbSchemaNormalized = 'true';
      organization.textContent = JSON.stringify(schema);
    } catch (error) {
      return false;
    }

    document.querySelectorAll('script[type="application/ld+json"][data-zb-generic-breadcrumb="innungsprofil"]').forEach((node) => node.remove());
    return true;
  }

  if (normalizeOrganizationSchema()) return;

  const observer = new MutationObserver(() => {
    const organization = document.getElementById('ipv-organization-schema');
    if (!organization) return;

    observer.disconnect();
    normalizeOrganizationSchema();
  });

  observer.observe(document.head, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 8000);
})();
